import { createAsyncThunk } from "@reduxjs/toolkit";

import { type AutomationTemplate } from "@fitness-app/data-models/entities/AutomationTemplate";

import { type AsyncThunkCreator } from "../../../index";
import { TEMPLATES_REDUCER_NAME } from "../types";

type Payload = {
  template: Partial<AutomationTemplate>;
  id: string;
};

export const updateTemplate = createAsyncThunk<AutomationTemplate, Payload, AsyncThunkCreator<string>>(
  `${TEMPLATES_REDUCER_NAME}/updateTemplate`,
  async (payload, { rejectWithValue, extra: { db, analytics } }) => {
    const { error, data } = await db
      .from("automation_template")
      .update(payload.template)
      .eq("id", payload.id)
      .select("*")
      .single<AutomationTemplate>();

    if (error) {
      return rejectWithValue(error.message);
    }

    analytics.track("update_template_automation");

    return data;
  },
);
